/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  SET_ENTITIES,
  SET_ENTITY,
  REMOVE_ENTITIES,
  RENAME_ENTITY,
  ADD_ENTITIES,
  FILTERED_ROW_ENTITIES,
  INVENTORY_FILTER_ENTITIES,
  SET_QUICK_FILTER,
  FILTERED_ROW_ENTITIES_CONTAINERS,
} from "./actionTypes";

export const inventoryfilterEntities = (searchData) => {
  return {
    type: INVENTORY_FILTER_ENTITIES,
    searchData,
  };
};

export const setQuickFilterEntities = (quickFilter) => {
  return {
    type: SET_QUICK_FILTER,
    quickFilter,
  };
};

export const filteredRowEntities = (visibleRowCount) => {
  return {
    type: FILTERED_ROW_ENTITIES,
    visibleRowCount: visibleRowCount,
  };
};
export const filteredRowEntitiesContainers = (visibleRowCount) => {
  return {
    type: FILTERED_ROW_ENTITIES_CONTAINERS,
    visibleRowCount: visibleRowCount,
  };
};
export function setEntities(items) {
  return {
    type: SET_ENTITIES,
    items: items,
  };
}

export function addEntities(items) {
  return {
    type: ADD_ENTITIES,
    items: items,
  };
}

export function setEntity(item) {
  return {
    type: SET_ENTITY,
    item: item,
  };
}

export function removeEntities(items) {
  return {
    type: REMOVE_ENTITIES,
    items: items,
  };
}

export function renameEntity(name) {
  return {
    type: RENAME_ENTITY,
    name: name,
  };
}
